import React from 'react';
import {Button, Col, Container, Row} from 'reactstrap';
import TntgCountdownSection from 'components/TntgCountdownSection';
import ShareButtons from 'components/ShareButtons';
import OptInForm from 'components/OptInForm';
import logoTntg from 'static/logo-tntg.png';
import Laurels from 'components/Laurels';
import ShowIf from 'funnel-schedule/ShowIf';
import HideIf from 'funnel-schedule/HideIf';

export default function () {
  return (
    <div className="fullsize background-cover background-fixed background-image-center background-image-grid background-overlay-black-70 background-overlay-fixed">
      <div className="page">
        <div className="wrapper">
          <Container>
            <Row className="d-flex justify-content-center mb-4">
              <Col xs="12" lg="10" xl="8">
                <Laurels white />
              </Col>
            </Row>
            <Row className="d-flex justify-content-center align-items-center mb-5">
              <Col xs="12" md="10" lg="8" xl="6">
                <div className="background-white rounded text-center p-4">
                  <Row className="d-flex justify-content-center mb-3">
                    <Col xs="7">
                      <img className="img-fluid" src={logoTntg} />
                    </Col>
                  </Row>
                  <p>
                    The world’s got some big problems. Are you ready for SOLUTIONS? Find out how humanity will
                    regenerate this planet in Rosario Dawson’s award-winning documentary film. This heartwarming story
                    of game-changing solutions MUST be seen far and wide. The world cannot wait.
                  </p>
                  <HideIf phase="after">
                    <OptInForm id="noTrailerOptinForm" />
                  </HideIf>
                  <ShowIf phase="after">
                    <h4 className="text-condensed text-800 mt-4 mb-2">The global premiere has ended.</h4>
                    <p className="mb-3">Click below to learn how you can still get access now!</p>
                    <Button
                      color="cta"
                      size="lg"
                      className="btn-size-300 text-uppercase text-white text-condensed text-800 mb-3"
                      href="/impact/"
                    >
                      Get access to <em>The Need To GROW</em> here
                    </Button>
                  </ShowIf>
                </div>
              </Col>
            </Row>

            <HideIf phase="after">
              <TntgCountdownSection className="mb-5" />
            </HideIf>

            <Row className="d-flex justify-content-center text-center text-white">
              <Col>
                <h5 className="mb-0">“No human being on the planet should miss this film.”</h5>
                <p>
                  <em>— Society of Voice Arts and Sciences</em>
                </p>

                <h5 className="mb-0">“Perhaps the best film on sustainability I have ever seen.”</h5>
                <p>
                  <em>— Teddy Grouya, Founding Director - American Documentary Film Festival</em>
                </p>

                <h5 className="mb-0">
                  “I loved this movie...it was one of those environmental movies that gave me hope.”
                </h5>
                <p className="mb-0">
                  <em>— Todd James, Global News</em>
                </p>
              </Col>
            </Row>
          </Container>
        </div>
        <ShareButtons floating />
      </div>
    </div>
  );
}
